import React from 'react';
import { Tabs, Button } from '@components';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { useSelector } from 'react-redux';

export const PerfilInvestimentoPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const {
    questionario_investidor: showQuestionario,
    historico_perfil: showHistoricoPerfil,
  } = useSelector((state) => state.configs.telasDisponiveis.data);

  const activeTab = () => {
    if (location.pathname.includes('trocaPerfil')) return 'Perfil atual';
    if (location.pathname.includes('questionario')) return 'Questionário';
    if (location.pathname.includes('intencaoMudancaPerfil'))
      return 'Histórico de Intenção de Mudança de Perfil';
    return 'Histórico Mudança de Perfil';
  };

  return (
    <>
      <Helmet>
        <title>Forluz - Perfil de Investidor</title>
      </Helmet>
      <h1 className="fw-bold page-title ">Perfil de Investidor</h1>
      <hr className="my-4" />
      <div className="d-flex col-3 col-md-2 col-lg-1 justify-content-center">
        <Button
          className="justify-content-center mb-32"
          transparent
          color="orange"
          icon="arrow_back"
          onClick={() => navigate(-1)}
        >
          Voltar
        </Button>
      </div>
      <Tabs active={activeTab}>
        <div
          label="Perfil atual"
          onClick={() => navigate('trocaPerfil')}
          aria-hidden
        >
          <Outlet />
        </div>

        {showQuestionario && (
          <div
            label="Questionário"
            onClick={() => navigate('questionario')}
            aria-hidden
          >
            <Outlet />
          </div>
        )}

        {showHistoricoPerfil && (
          <div
            label="Histórico de Intenção de Mudança de Perfil"
            onClick={() => navigate('intencaoMudancaPerfil')}
            aria-hidden
          >
            <Outlet />
          </div>
        )}
        {showHistoricoPerfil && (
          <div
            label="Histórico Mudança de Perfil"
            onClick={() => navigate('mudancaPerfil')}
            aria-hidden
          >
            <Outlet />
          </div>
        )}
      </Tabs>
    </>
  );
};
